import { useEffect, useState } from "react";
import { api } from "./api";
import { CITIES } from "./site";

let cache = null;

export const useCities = () => {
  const [cities, setCities] = useState(cache ?? CITIES);
  useEffect(() => {
    if (cache) return undefined;
    let alive = true;
    api.get("/cities").then((r) => {
      const list = Array.isArray(r.data?.cities) ? r.data.cities : [];
      if (alive && list.length) { cache = list; setCities(list); }
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return cities;
};
